import React from 'react';
import {
    Stack,
    Breadcrumb,
    Divider,
    Container,
    IconButton,
    Whisper,
    Tooltip,
} from 'rsuite';
import QrcodeIcon from '@rsuite/icons/Qrcode';
import AddOutlineIcon from '@rsuite/icons/AddOutline';
import TrashIcon from '@rsuite/icons/Trash';
import SettingHorizontalIcon from '@rsuite/icons/SettingHorizontal';
import { Link } from 'react-router-dom';
import GearIcon from '@rsuite/icons/Gear';
import SentToUserIcon from '@rsuite/icons/SentToUser';
import CouponIcon from '@rsuite/icons/Coupon';
import ugr from '@/UGRoute';

const FairHome = () => {

    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Fair</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to={`/${ugr}/dashboard`}>
                                        Home</Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>Fair</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                        <h5>Welcome To Fair</h5>
                    </Stack>
                </Stack>
                <Divider className='divide' />
                <div className="row" >

                    <Stack justifyContent='space-around' spacing={25}>
                        <Whisper speaker={<Tooltip >Fair Master</Tooltip>}>
                            <Link to={`/${ugr}/masterF`}>
                                <IconButton size="lg" icon={<SettingHorizontalIcon style={{ fontSize: '75px', opacity: 0.3 }} />} active />
                            </Link>
                        </Whisper>
                        <Whisper speaker={<Tooltip >Fair Products</Tooltip>}>
                            <Link to={`/${ugr}/fairCreate`}>
                                <IconButton size="lg" icon={<AddOutlineIcon style={{ fontSize: '75px', opacity: 0.3 }} />} active />
                            </Link>
                        </Whisper>
                        <Whisper speaker={<Tooltip >Remove Fair Products</Tooltip>}>
                            <Link to={`/${ugr}/fairRemove`}>
                                <IconButton size="lg" icon={<TrashIcon style={{ fontSize: '75px', opacity: 0.3 }} />} active />
                            </Link>
                        </Whisper>
                    </Stack>
                    <Stack justifyContent='space-around' spacing={25} style={{ marginTop: '50px' }}>
                        <Whisper speaker={<Tooltip >Print QR Print</Tooltip>} >
                            <Link to={`/${ugr}/qrPrint`}>
                                <IconButton size="lg" icon={<QrcodeIcon style={{ fontSize: '75px', opacity: 0.3 }} />} active />
                            </Link>
                        </Whisper>
                        <Whisper speaker={<Tooltip >Setting</Tooltip>}>
                            <Link to={`/${ugr}/settings`}>
                                <IconButton size="lg" icon={<GearIcon style={{ fontSize: '75px', opacity: 0.3 }} />} active />
                            </Link>
                        </Whisper>
                        <Whisper speaker={<Tooltip >Enquiry Tracker</Tooltip>}>
                            <Link to={`/${ugr}/enquiry`}>
                                <IconButton size="lg" icon={<SentToUserIcon style={{ fontSize: '75px', opacity: 0.3 }} />} active />
                            </Link>
                        </Whisper>
                    </Stack>
                    <Stack justifyContent='space-around' spacing={25} style={{ marginTop: '50px' }}>
                        <Whisper speaker={<Tooltip >Price Management</Tooltip>} >
                            <Link to={`/${ugr}/priceManage`}>
                                <IconButton size="lg" icon={<CouponIcon style={{ fontSize: '75px', opacity: 0.3 }} />} active />
                            </Link>
                        </Whisper>

                    </Stack>



                </div>

                <Stack className="copyright" justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
                </Stack>
            </Container>
        </>
    )
}

export default FairHome;